import {
  AnnotatedDeepLink,
  DeepLinkType,
  SnippetV1State,
} from "pages/api/deep-links/types";
import { useMemo } from "react";
import { useDeepLinks } from "./useDeepLinks";

export function useSnippets({
  isForCard, // true for cards, false/empty for the others
  isTagged, // will match all the tags in the list
  onlyUserOwned, // excludes org/vzbl
}: Partial<{
  isForCard: boolean;
  isTagged: string[];
  onlyUserOwned: boolean;
}> = {}): {
  list: AnnotatedDeepLink[];
  isFetched: boolean;
  isLoading: boolean;
} {
  const {
    links: { data = [], isLoading, isFetched },
  } = useDeepLinks(DeepLinkType.SNIPPET);
  const list = useMemo(
    () =>
      data.filter((snippet) => {
        if (
          isForCard &&
          !(snippet.json as SnippetV1State | undefined)?.isForCards
        )
          return false;
        if (
          !isForCard &&
          (snippet.json as SnippetV1State | undefined)?.isForCards
        )
          return false;

        if (onlyUserOwned && !(snippet.orgId && snippet.userId)) return false;

        if (isTagged && isTagged.length > 0) {
          const tags = (snippet.json as SnippetV1State | undefined)?.tags || [];
          if (!tags.some((tag) => isTagged.includes(tag))) return false;
        }

        return true;
      }),
    [data, isForCard, onlyUserOwned, isTagged]
  );
  return { list, isLoading, isFetched };
}
